import React, { CSSProperties } from 'react';
import history from 'app-router/history';

const ItemLink = ({ to, name, style }: { to: string; name: string; style?: CSSProperties }) => {
  const clickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    history.push(to);
  };

  return (
    <a href={to} onClick={clickHandler} style={style ? style : { color: 'inherit' }}>
      {name}
    </a>
  );
};

export default ItemLink;
